(function () {
  'use strict';

  /* ── Turnstile token cache ── */
  var _turnstileToken = '';
  window.onGiftTurnstile = function (token) {
    _turnstileToken = token;
  };

  /* ── エラーコード → 日本語メッセージ ── */
  var ERROR_MESSAGES = {
    TURNSTILE_FAILED: 'セキュリティ確認に失敗しました。ページを再読み込みしてお試しください。',
    RATE_LIMITED: 'しばらく時間をおいてから再度お試しください。',
    DUPLICATE: 'このメールアドレスでは既にお申込みを受け付けております。',
    INVALID_INPUT: '入力内容に誤りがあります。各項目をご確認ください。',
  };

  function getErrorMessage(code) {
    return ERROR_MESSAGES[code] || '申込みに失敗しました。時間を置いて再度お試しください。';
  }

  /* ── DOM 取得 ── */
  var form = document.getElementById('product-gift-form');
  if (!form) return;

  var submitBtn = form.querySelector('.product-gift-form__submit');
  var errorEl = document.getElementById('pgf-error');
  var thanksEl = document.getElementById('pgf-thanks');
  var headerEl = document.querySelector('.product-gift-form > .product-gift-form__header');

  /* ────────────────────────────────────────────
   * thanks 表示ヘルパー
   *   pushHistory = true  → 成功時（URL を ?status=thanks に書換 + 履歴追加）
   *   pushHistory = false → リロード初期化時（URL はそのまま）
   * ──────────────────────────────────────────── */
  function showThanks(pushHistory) {
    if (!thanksEl) return;

    if (pushHistory) {
      var url = new URL(window.location.href);
      history.pushState(
        { thanks: true },
        '',
        url.pathname + '?status=thanks'
      );
    }

    /* フォームを 200ms で fade-out してから非表示 */
    form.classList.add('product-gift-form__form--fading');
    if (headerEl) headerEl.classList.add('product-gift-form__form--fading');
    setTimeout(function () {
      form.setAttribute('hidden', '');
      form.classList.remove('product-gift-form__form--fading');
      if (headerEl) {
        headerEl.setAttribute('hidden', '');
        headerEl.classList.remove('product-gift-form__form--fading');
      }

      /* thanks を DOM に出してから opacity transition を走らせる（rAF 二重） */
      thanksEl.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          thanksEl.classList.add('product-gift-form__thanks--visible');
        });
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 200);
  }

  /* ────────────────────────────────────────────
   * フォーム復元ヘルパー（popstate でフォームに戻る時）
   * ──────────────────────────────────────────── */
  function restoreForm() {
    if (!thanksEl) return;
    thanksEl.classList.remove('product-gift-form__thanks--visible');
    thanksEl.setAttribute('hidden', '');
    form.removeAttribute('hidden');
    if (headerEl) headerEl.removeAttribute('hidden');
    clearError();
  }

  /* ────────────────────────────────────────────
   * ページロード時に ?status=thanks を読む
   * ユーザーがリロードしても thanks 状態を保持
   * ──────────────────────────────────────────── */
  var initialParams = new URLSearchParams(window.location.search);
  if (initialParams.get('status') === 'thanks') {
    /* リロード時は pushState 不要 */
    if (thanksEl) {
      thanksEl.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          thanksEl.classList.add('product-gift-form__thanks--visible');
        });
      });
    }
    form.setAttribute('hidden', '');
    if (headerEl) headerEl.setAttribute('hidden', '');
  }

  /* ────────────────────────────────────────────
   * popstate：ブラウザ「戻る」でフォームを復元
   * ──────────────────────────────────────────── */
  window.addEventListener('popstate', function (e) {
    var state = e.state;
    if (state && state.thanks) {
      /* 「進む」で thanks に戻った場合 */
      showThanks(false);
    } else {
      /* 「戻る」でフォームに戻った場合 */
      restoreForm();
    }
  });

  /* ── checkbox max-3 制御 ── */
  var fieldset = form.querySelector('[data-max-checks]');
  if (fieldset) {
    var maxChecks = parseInt(fieldset.getAttribute('data-max-checks'), 10) || 3;
    var allChecks = Array.from(fieldset.querySelectorAll('[data-priority-check]'));

    var refreshCheckState = function () {
      var checked = allChecks.filter(function (b) { return b.checked; });
      var limitReached = checked.length >= maxChecks;
      allChecks.forEach(function (c) {
        var wrap = c.closest('.product-gift-form__checkbox');
        if (wrap) wrap.classList.toggle('product-gift-form__checkbox--checked', c.checked);
        c.disabled = limitReached && !c.checked;
        if (wrap) wrap.classList.toggle('product-gift-form__checkbox--disabled', c.disabled);
      });
    };

    allChecks.forEach(function (box) {
      box.addEventListener('change', refreshCheckState);
    });

    refreshCheckState();
  }

  /* ────────────────────────────────────────────
   * 郵便番号 → 住所 自動入力 (zipcloud API)
   * 都道府県 / 市区町村 は常に上書き、町域 (address1) は
   * 未入力の場合のみ自動投入し、ユーザーが入れた番地は保持する
   * ──────────────────────────────────────────── */
  (function setupZipLookup() {
    var zipEl = document.getElementById('pgf-zip');
    var provinceEl = document.getElementById('pgf-province');
    var cityEl = document.getElementById('pgf-city');
    var address1El = document.getElementById('pgf-address1');
    if (!zipEl) return;

    var lookingUp = false;
    var lastLookedUp = '';

    function lookupZip() {
      var digits = (zipEl.value || '').replace(/[^\d]/g, '');
      if (digits.length !== 7) return;
      if (lookingUp || digits === lastLookedUp) return;
      lookingUp = true;
      lastLookedUp = digits;

      fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + encodeURIComponent(digits))
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (!json || !json.results || !json.results.length) return;
          var r = json.results[0];
          if (provinceEl && r.address1) provinceEl.value = r.address1;
          if (cityEl && r.address2) cityEl.value = r.address2;
          if (address1El && r.address3 && !address1El.value.trim()) {
            address1El.value = r.address3;
            try { address1El.focus(); } catch (_) { /* noop */ }
          }
        })
        .catch(function () { /* silent: 失敗時は手入力で */ })
        .then(function () { lookingUp = false; });
    }

    zipEl.addEventListener('blur', lookupZip);
    zipEl.addEventListener('input', function () {
      var digits = (zipEl.value || '').replace(/[^\d]/g, '');
      if (digits.length === 7) lookupZip();
    });
  })();

  /* ── エラー表示 / 非表示 ── */
  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.removeAttribute('hidden');
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.setAttribute('hidden', '');
  }

  /* ── 送信中状態の切替 ── */
  function setSubmitting(on) {
    if (!submitBtn) return;
    submitBtn.disabled = on;
    submitBtn.textContent = on ? '送信中...' : '申込を確定する';
  }

  /* ── submit ── */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();

    /* こだわり最低 1 件バリデーション */
    if (fieldset) {
      var checkedBoxes = Array.from(fieldset.querySelectorAll('[data-priority-check]:checked'));
      if (checkedBoxes.length === 0) {
        showError('「大切にしていること」を1つ以上お選びください。');
        fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }

    /* Worker URL 未設定なら demo モード: API 接続せず即サンクス画面 */
    var workerUrl = (form.dataset.workerUrl || '').trim();
    if (!workerUrl) {
      setSubmitting(true);
      setTimeout(function () { showThanks(true); }, 300);
      return;
    }

    /* FormData → プレーンオブジェクト変換 */
    var fd = new FormData(form);
    var payload = {};

    fd.forEach(function (value, key) {
      if (key === 'priorities') {
        if (!Array.isArray(payload.priorities)) payload.priorities = [];
        payload.priorities.push(value);
      } else {
        payload[key] = value;
      }
    });

    if (!payload.priorities) payload.priorities = [];
    payload.variantId = form.dataset.variantId || '';
    payload.turnstileToken = _turnstileToken;

    setSubmitting(true);

    fetch(workerUrl + '/api/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.ok) {
          /* 成功 → SPA 的演出で thanks 表示、URL を書き換える */
          showThanks(true);
          return;
        }
        return res.json().catch(function () { return {}; }).then(function (body) {
          var code = (body && body.code) ? body.code : String(res.status);
          var msg = (body && body.message) ? body.message : getErrorMessage(code);
          throw new Error(msg);
        });
      })
      .catch(function (err) {
        showError(err.message || getErrorMessage(''));
        setSubmitting(false);
        if (window.turnstile) {
          window.turnstile.reset();
          _turnstileToken = '';
        }
      });
  });
})();
